<template>
    <!-- 弹窗遮罩 -->
    <div class="lite_popup" v-show="show">
        <!-- 弹窗 -->
        <div class="lite_popup_box">
            <!-- 标题栏 -->
            <div class="lite_popup_title">
                <!-- 标题 -->
                <span>{{ data.title }}</span>
                <!-- 关闭图标 -->
                <div class="icon white-close dialog-close" @click="show = false"></div>
            </div>
            <!-- 内容 -->
            <div class="lite_popup_content lite_popup_content_confim_check">
                <div>{{ data.desc1 }}</div>
                <div>{{ data.desc2 }}</div>
                <div>{{ data.desc3 }}</div>
                <el-input ref="input" @keyup.esc.native="show = false" @keyup.enter.native="ok" v-model="data.nameCheck" :placeholder="data.name"></el-input>
            </div>
            <div class="lite_popup_footer">
                <!-- 按钮 -->
                <button ref="okBtn" @keyup.esc="show = false" @keyup.enter="ok" @click="ok">{{$t('language.common.ok')}}</button>
            </div>
        </div>
    </div>
</template>

<script>
import { Message } from "element-ui";

export default {
    props: {
        data: {
            title: { type: String, default: 'Title' },
            desc1: { type: String, default: 'Description content 1' },
            desc2: { type: String, default: 'Description content 2' },
            desc3: { type: String, default: 'Description content 3' },
            name: { type: String, default: 'Name' },
            nameCheck: { type: String, default: 'Name Check' },
        }
    },
    data() {
        return {
            show: false,
        };
    },
    watch: {
        show(val) {
            if (val) {
                this.$nextTick(() => {
                    this.$refs.okBtn.focus();
                });
            }
        }
    },
    methods: {
        ok() {
            if (this.data.nameCheck != this.data.name) {
                Message.warning(this.$t('language.popup.cloudExploerPopup.deleteDeletionOK'))
                return
            } else {
                this.show = false
                this.$emit('ok');
            }
        },
    }
};
</script>

<style>
/* 弹窗宽度 */
.lite_popup_box {
    width: 600px;
}
/* 文字间隔 */
.lite_popup_content_confim_check>div {
    height: 30px;
    line-height: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/workspace/lite_confirm_check.vue